import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import MembershipBreakdownPieChart from "./smartComponents/membershipBreakdownPieChart";
import MembershipBreakdownTable from "./smartComponents/membershipBreakdownTable";
import SingleDatePicker from "./smartComponents/singleDatePicker";
import { actionCreators } from "./redux/membershipBreakdownSaga";
import IncludeZeroSales from "./smartComponents/includeSales";
import StatusTypes from "./smartComponents/statusTypes";
import GroupBy from "./smartComponents/groupBy";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import NoData from "../../../components/noData/noData";
import "./membershipBreakdownModule.css.scss";

const MembershipBreakdownModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    membershipsInfo: { data = [] },
    tableLoading,
    initialRequest
  } = useSelector((state) => state.membershipBreakdown);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const getContent = () => {
    return (
      <>
        <div id="membershipBreakdownModule">
          <div className="dropdown dropdown-actions actions">
            <div className="filters-wrapper">
              <div className="select-box" style={{ width: 170 }}>
                <p>Group by</p>
                <GroupBy />
              </div>

              <div className="select-box include-sales-dropdown" style={{ width: 120 }}>
                <p>Include $0 Sales</p>
                <IncludeZeroSales />
              </div>
            </div>
            <SingleDatePicker />
          </div>
          {data.length > 0 ? (
            tableLoading ? (
              <LoadingAnimation />
            ) : (
              <>
                <MembershipBreakdownTable />
                <div className="pie-chart">
                  <MembershipBreakdownPieChart />
                </div>
              </>
            )
          ) : (
            <NoData size="big" />
          )}
        </div>
      </>
    );
  };

  return (
    <SectionToggle
      isLoading={isLoading}
      title="Membership Breakdown by"
      content={getContent()}
      learnMore={
        <>
          <StatusTypes />
          <KBLearnMore
            title="Membership Breakdown"
            description="This report shows all memberships grouped by key attributes, giving you a clear view of your membership composition and revenue distribution. These insights help you understand which membership types drive value and how your member base is structured over time."
            kbUrl={ILEARN_URLS.membership.membershipBreakdown}
          />
        </>
      }
    />
  );
};

export default React.memo(MembershipBreakdownModule);
